"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Button_1 = tslib_1.__importDefault(require("@mui/material/Button"));
const Card_1 = tslib_1.__importDefault(require("@mui/material/Card"));
const CardContent_1 = tslib_1.__importDefault(require("@mui/material/CardContent"));
const CardContent_2 = tslib_1.__importDefault(require("@mui/material/CardContent"));
const CardHeader_1 = tslib_1.__importDefault(require("@mui/material/CardHeader"));
const Divider_1 = tslib_1.__importDefault(require("@mui/material/Divider"));
const Paper_1 = tslib_1.__importDefault(require("@mui/material/Paper"));
const Popover_1 = tslib_1.__importDefault(require("@mui/material/Popover"));
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
const styles_1 = require("@mui/material/styles");
const ButtonPrimaryAction_1 = tslib_1.__importDefault(require("../ButtonPrimaryAction"));
/**
 * Use this simple variant if your beta page reuses the url of the old page.
 * See BetaButton for a richer experience.
 *
 * See Hera sketches for UX details: https://zeroheight.com/5a26bc445/p/794afa-beta
 *
 * @param isBeta A boolean indicating if beta is enabled
 * @param setBeta Function to call to change beta enabled
 * @param title The dialog header text
 * @param content Text or rich content inside the dialog
 *
 * Note that the component uses some locale text internally for default button texts.
 *
 *
 * @category component
 *
 * @example
 * This example shows a basic rendering of this component
 *
 * ```jsx live noInline
 * file://./__examples__/1_BetaButtonSimple.jsx
 * ```
 */
const BetaButtonSimple = (props) => {
    const { isBeta, setBeta, title, maxWidth = 520, content } = props;
    const { getBetaButtonText, getOkButtonText, cancelButtonText } = (0, styles_1.useThemeProps)({
        props,
        name: "MneBetaButtonSimple",
    });
    const [anchorEl, setAnchorEl] = react_1.default.useState(null);
    const [open, setOpen] = react_1.default.useState(false);
    const handleBtnClick = (event) => {
        setAnchorEl(event.currentTarget);
        setOpen(!open);
    };
    const handleBetaToggle = () => {
        setOpen(!open);
        setBeta(!isBeta);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Paper_1.default, { elevation: 0, sx: { display: "inline-block" } },
            react_1.default.createElement(Button_1.default, { variant: isBeta ? "contained" : "outlined", color: "primary", onClick: (e) => handleBtnClick(e) }, getBetaButtonText(isBeta))),
        react_1.default.createElement(Popover_1.default, { open: open, anchorEl: anchorEl, anchorOrigin: { vertical: "bottom", horizontal: "left" }, onClose: () => setOpen(false) },
            react_1.default.createElement(Card_1.default, { sx: { maxWidth } },
                react_1.default.createElement(CardHeader_1.default, { role: "heading", title: title, titleTypographyProps: { variant: "h6", fontWeight: "bold" } }),
                react_1.default.createElement(Divider_1.default, null),
                react_1.default.createElement(CardContent_2.default, null,
                    react_1.default.createElement(Typography_1.default, { variant: "body1", component: "span" }, content)),
                react_1.default.createElement(Divider_1.default, null),
                react_1.default.createElement(StyledCardActions, null,
                    react_1.default.createElement(Button_1.default, { variant: "text", onClick: () => setOpen(false) }, cancelButtonText),
                    react_1.default.createElement(ButtonPrimaryAction_1.default, { variant: "contained", color: "secondary", onClick: handleBetaToggle }, getOkButtonText(isBeta)))))));
};
const StyledCardActions = (0, styles_1.styled)(CardContent_1.default)(({ theme }) => ({
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.spacing(1),
    padding: theme.spacing(1),
    "&:last-child": {
        paddingBottom: theme.spacing(1),
    },
}));
exports.default = BetaButtonSimple;
